export default __webpack_public_path__ + "static/media/mv-lg-bg.a447b5b8.jpg";